declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

const env = {
  get: (key: string): string | undefined => {
    if (
      window.__ENV__ &&
      window.__ENV__[key] !== undefined &&
      window.__ENV__[key] !== ''
    ) {
      return window.__ENV__[key];
    }
    return (import.meta.env as Record<string, string | undefined>)[key];
  },
};

export default env;
